import { createElement, useState } from 'react'
import type { CSSProperties, ElementType, ReactNode } from 'react'

type HoverProps = {
  as?: ElementType
  style?: CSSProperties
  /** Styles merged on top of `style` while hovered — the port of `style-hover`. */
  hoverStyle?: CSSProperties
  children?: ReactNode
} & Record<string, unknown>

/**
 * Polymorphic element that merges `hoverStyle` over `style` on hover.
 *
 * The original bundle implemented `style-hover="..."` by minting a scoped class
 * with a real `:hover` rule. We reproduce the identical visual result with React
 * state; every other prop (onClick, aria-*, etc.) passes straight through.
 */
export function Hover({ as = 'div', style, hoverStyle, children, ...rest }: HoverProps) {
  const [hovered, setHovered] = useState(false)
  return createElement(
    as,
    {
      ...rest,
      style: hovered && hoverStyle ? { ...style, ...hoverStyle } : style,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
    },
    children,
  )
}
